export default __webpack_public_path__ + "static/media/BA.5ebff926.svg";